import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'rebass';
import { Image, Button } from 'semantic-ui-react';

import { Text, SplitText } from '../Base';
import { COLOR, SPACE, FONT_SIZE } from '../Theme';
import { BrowseUniversityModal } from '../../Containers/BrowseUniversity';

const AddButton = styled(Button)`
  margin: 0px !important;
`;

const EmptyFaculty = ({ image, roundCode, onBrowseModalClose }) => (
  <Flex flexDirection="column" flex={1} justifyContent="space-around" alignItems="center">
    <Box p={SPACE.xlarge}>
      <Image src={image} style={{ maxWidth: 240, marginBottom: 15 }} />
      <Text fontSize={FONT_SIZE.semilarge} textAlign="center" color={COLOR.greyscale.grey3}>
        ยังไม่ได้เลือกคณะที่น้องอยากเข้า
      </Text>
    </Box>
    <Box>
      <BrowseUniversityModal
        trigger={
          <AddButton primary circular>
            <Text is="span" fontWeight="400" color={COLOR.white}>
              <SplitText left="เลือกคณะ" right="สาขา" seperator="/" align="center" />
            </Text>
          </AddButton>
        }
        roundCode={roundCode}
        mockExam
        hideHeart
        onClose={onBrowseModalClose}
      />
    </Box>
  </Flex>
);

export default EmptyFaculty;
